import { PurchaseRecordPreview } from "./PreviewPurchseOrders.jsx";
export default function Preview({ receiveItem, ...props }) {
  return <PurchaseRecordPreview record={receiveItem} kind="receive" {...props} />;
}
